module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/16_9.493b1c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/16_9.jpg
// module id = 46Qj
// module chunks = 1